<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        Employees
        <span class="badge text-dark bg-body-secondary ms-2">{{ TotalEmployee }}</span>
      </h5>
      <div class="d-flex">
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group has-prefix">
              <i class="prefix bi bi-search"></i>
              <input type="text" class="form-control" name="query" placeholder="Search Employee" title="Search Employee" (keyup)="SearchData()" [(ngModel)]="SearchVal" />
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-primary" (click)="OpenPopup(addEmployeeModal)"><i class="bi bi-plus"></i> Add Employee</button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" [ngClass]="{ 'table-fixed': IsLoading }" *ngIf="TotalEmployee || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">
              <button
                class="btn btn-sm p-0 btn-sort"
                (click)="SortData('firstName')"
                [ngClass]="this.PaginationParams.sortColumn === 'firstName' ? this.PaginationParams.sortOrder : ''"
                [disabled]="IsLoading"
              >
                Employee Name
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">Title</th>
            <th scope="col">
              <button
                (click)="SortData('phoneNumber')"
                class="btn btn-sm p-0 btn-sort"
                [ngClass]="this.PaginationParams.sortColumn === 'phoneNumber' ? this.PaginationParams.sortOrder : ''"
                [disabled]="IsLoading"
              >
                Phone
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">
              <button
                (click)="SortData('email')"
                class="btn btn-sm p-0 btn-sort"
                [ngClass]="this.PaginationParams.sortColumn === 'email' ? this.PaginationParams.sortOrder : ''"
                [disabled]="IsLoading"
              >
                Email
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">Clinic</th>
            <th scope="col">Role</th>
            <th scope="col" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!IsLoading">
            <tr *ngFor="let employee of EmployeeList; index as i">
              <th scope="row">{{ i + 1 + PaginationParams.skip }}</th>
              <td>{{ employee.firstName }} {{ employee.lastName }}</td>
              <td>{{ employee.title }}</td>
              <td>{{ employee.phoneNumber | phonenumber : 'format' }}</td>
              <td>{{ employee.email }}</td>
              <td>{{ employee.clinicName }}</td>
              <td>{{ employee.roleId == 1 ? 'Admin' : 'Employee' }}</td>

              <td class="text-end">
                <button type="button" class="btn btn-sm" *ngIf="employee.id" (click)="OpenPopup(addEmployeeModal, true, employee.id)">
                  <i class="bi bi-pencil-square fs-5"></i>
                </button>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="IsLoading">
            <tr *ngFor="let employee of ['', '', '', '', '']; index as i">
              <td *ngFor="let employee of ['', '', '', '', '', '', '', '']; index as i">
                <p class="placeholder-glow">
                  <span class="placeholder col-12"></span>
                </p>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="!TotalEmployee && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Employees Found</p>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer" *ngIf="TotalEmployee">
    <app-pagination [totalItems]="TotalEmployee" [pageSize]="PaginationParams.take" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" />
  </div>
</div>

<!-- Add Employee -->
<ng-template #addEmployeeModal let-close="close" let-dismiss="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">{{ IsEditEmployee ? 'Edit' : 'Add' }} Employee</h5>
    <button type="button" class="btn-close" (click)="EmplForm.reset(); dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <!-- Floating Labels Form -->
    <form class="row g-3" (ngSubmit)="AddEmployee()" [formGroup]="EmplForm">
      <div class="col-md-6">
        <div class="form-group">
          <label for="fName">First Name</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('firstName')?.invalid && EmplForm.get('firstName')?.touched
            }"
          >
            <input type="text" formControlName="firstName" class="form-control" id="fName" placeholder="First Name" #fName />
            <span class="error-message" *ngIf="EmplForm.get('firstName')?.errors?.['required'] && EmplForm.get('firstName')?.touched"> This is required field </span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="lname">Last Name</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('lastName')?.invalid && EmplForm.get('lastName')?.touched
            }"
          >
            <input type="text" formControlName="lastName" class="form-control" id="lname" placeholder="Last Name" #lName />
            <span class="error-message" *ngIf="EmplForm.get('lastName')?.errors?.['required'] && EmplForm.get('lastName')?.touched"> This is required field </span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="phone">Phone number</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('phoneNumber')?.invalid && EmplForm.get('phoneNumber')?.touched
            }"
          >
            <input
              type="text"
              (keydown)="sharedService.validateNumber($event)"
              [value]="EmplForm.get('phoneNumber')?.value | phonenumber : 'format'"
              formControlName="phoneNumber"
              class="form-control"
              [maxlength]="MaxPhoneLength"
              id="phone"
              placeholder="Phone number"
            />
            <span class="error-message" *ngIf="EmplForm.get('phoneNumber')?.errors?.['required'] && EmplForm.get('phoneNumber')?.touched"> This is required field </span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="title">Title</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('title')?.invalid && EmplForm.get('title')?.touched
            }"
          >
            <input type="text" formControlName="title" class="form-control" id="title" placeholder="Title" />

            <span class="error-message" *ngIf="EmplForm.get('title')?.errors?.['required'] && EmplForm.get('title')?.touched">This is required field</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="email">Email</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('email')?.invalid && EmplForm.get('email')?.touched
            }"
          >
            <input type="string" formControlName="email" class="form-control" id="email" placeholder="Email" autocomplete="off" />
            <span *ngIf="EmplForm.get('email')?.touched">
              <span class="error-message" *ngIf="EmplForm.get('email')?.errors?.['required']"> This is required field </span>
              <span class="error-message" *ngIf="EmplForm.get('email')?.errors?.['email']"> Invalid Email </span>
            </span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="d-flex justify-content-between w-100">
            <label for="password">Password</label>
            <button class="btn btn-sm btn-link" type="button" tabindex="-1" *ngIf="!IsEditEmployee" (click)="ShowPassword = !ShowPassword">{{ ShowPassword ? 'Hide' : 'Show' }} Password</button>
          </div>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('password')?.invalid && EmplForm.get('password')?.touched
            }"
          >
            <input [type]="ShowPassword ? 'text' : 'password'" formControlName="password" class="form-control" id="password" placeholder="Password" autocomplete="new-password" />
            <ul class="error-message ps-3 mt-1" *ngIf="EmplForm.get('password')?.invalid && EmplForm.get('password')?.dirty && EmplForm.get('password')?.touched">
              <li *ngIf="EmplForm.get('password')?.errors?.['required']">Password is required.</li>
              <li *ngIf="EmplForm.get('password')?.errors?.['minlength']">Password must be at least 8 characters long.</li>
              <li *ngIf="EmplForm.get('password')?.errors?.['maxlength']">Password must not exceed 16 characters.</li>
              <li *ngIf="EmplForm.get('password')?.errors?.['uppercase']">Password must contain at least one uppercase letter.</li>
              <li *ngIf="EmplForm.get('password')?.errors?.['lowercase']">Password must contain at least one lowercase letter.</li>
              <li *ngIf="EmplForm.get('password')?.errors?.['number']">Password must contain at least one number.</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="role">Role</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('roleId')?.invalid && EmplForm.get('roleId')?.touched
            }"
          >
            <select class="form-select form-control" id="role" formControlName="roleId" aria-label="role">
              <option value="1">Admin</option>
              <option value="2">Employee</option>
            </select>

            <span class="error-message" *ngIf="EmplForm.get('roleId')?.errors?.['required'] && EmplForm.get('roleId')?.touched"> Please select Employee's Role </span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="caseType">Clinic</label>
          <div
            class="input-group"
            [ngClass]="{
              'has-invalid': EmplForm.get('clinicId')?.invalid && EmplForm.get('clinicId')?.touched
            }"
          >
            <select class="form-select form-control" formControlName="clinicId" id="clinicId" aria-label="Clinic">
              <ng-container *ngFor="let clinic of apiService.ClinicList.value">
                <option [value]="clinic.id">{{ clinic.clinicName }}</option>
              </ng-container>
            </select>
            <span class="error-message" *ngIf="EmplForm.get('clinicId')?.errors?.['required'] && EmplForm.get('clinicId')?.touched"> Please select Clinic </span>
          </div>
        </div>
      </div>
    </form>
    <!-- End floating Labels Form -->
  </div>
  <div class="modal-footer justify-content-between align-items-center">
    <div class="d-flex">
      <ng-container *ngIf="IsEditEmployee">
        <button type="button" (click)="DeleteEmployee(fName.value + ' ' + lName.value)" class="btn btn-danger">Delete Employee</button>
      </ng-container>
    </div>
    <div class="d-flex">
      <button type="button" class="btn btn-secondary" (click)="EmplForm.reset(); dismiss()">Cancel</button>
      <button type="button" (click)="close()" [disabled]="!EmplForm.valid || IsLoading" class="btn btn-primary ms-2" (click)="IsEditEmployee ? UpdateEmployee() : AddEmployee()">Save changes</button>
    </div>
  </div>
</ng-template>
